var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "product-form",
      attrs: { novalidate: "" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.addToCart.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "product-form__options" },
        [
          _vm.hasVariants
            ? _c("option-select-buttons", {
                staticClass: "product-form__options__option1",
                attrs: {
                  label: "Color",
                  product: _vm.product,
                  option: "option1"
                },
                model: {
                  value: _vm.selectedOption1,
                  callback: function($$v) {
                    _vm.selectedOption1 = $$v
                  },
                  expression: "selectedOption1"
                }
              })
            : _vm._e(),
          _vm.hasComplexVariants
            ? _c("option-select-buttons", {
                staticClass: "product-form__options__option2",
                attrs: {
                  label: "Size",
                  product: _vm.product,
                  option: "option2"
                },
                model: {
                  value: _vm.selectedOption2,
                  callback: function($$v) {
                    _vm.selectedOption2 = $$v
                  },
                  expression: "selectedOption2"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "product-form__atc" },
        [
          _c(
            "base-button",
            {
              staticClass: "product-form__submit",
              attrs: { disabled: _vm.isDisabled, loading: _vm.adding }
            },
            [_vm._v(_vm._s(_vm.buttonLabel))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }